import { createContext } from 'react';

export const LgContext = createContext(0);
LgContext.displayName = 'Lg';

export const LContext = createContext(0);
LContext.displayName = 'L';
